import { ResolvedPos } from 'prosemirror-model'
import { Selection } from 'prosemirror-state'

// returns the previous text position, or the same position if there is none
export const getPreviousTextPosition = (pos: ResolvedPos): ResolvedPos =>
  pos.doc.resolve(Selection.near(pos.doc.resolve(pos.pos ? pos.pos - 1 : 0), -1).from)
